import { useNavigate } from 'react-router-dom';

import { signOut } from '../lib/api.ts';
import { useSession } from './useSession.tsx';

/**
 * Signs out, tells every other tab (broadcastSignOut), and lands on /sign-in
 * with the email pre-filled (Push #88), as TopNav's sign-out does. AppShell uses
 * it; Shell 2c moves TopNav onto it.
 */
export function useSignOut(): () => Promise<void> {
  const { user, refresh, broadcastSignOut } = useSession();
  const navigate = useNavigate();
  return async () => {
    // Read before signOut() clears the session.
    const emailHint = user?.email;
    try {
      await signOut();
    } catch {
      // ignore
    }
    broadcastSignOut();
    refresh();
    navigate(emailHint ? `/sign-in?email=${encodeURIComponent(emailHint)}` : '/sign-in');
  };
}
